import { Alert } from '@cmsgov/ds-medicare-gov'
import { useTranslation } from 'react-i18next'

export function PlanHistoryEmptyAlert () {
  const { t } = useTranslation('accountHome', {
    keyPrefix: 'planHistory.noPlansAlert'
  })

  return (
    <Alert heading={t('heading')} hideIcon>
      {t('content')}
    </Alert>
  )
}
export default PlanHistoryEmptyAlert
